import { getOemLabel } from '../../helpers/getOemLabel';
import { getUnitSuffix } from '../../helpers/getUnitSuffix';
import { isAtOemDefault } from '../../helpers/isAtOemDefault';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import IntervalConfigRow from 'pages/MaintenancePage/components/IntervalConfigRow';
import { getAvailableUnits } from 'pages/MaintenancePage/helpers/getAvailableUnits';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const IntervalConfigRows: FunctionComponent<Props> = ({
    className = '',
    draftIntervals,
    isAdmin,
    oemDefaults,
    onChange,
    onReset,
    onUnitChange,
    partLabels,
    parts,
    strings,
    testId = TEST_ID,
    unitLabels
}) => (
    <VerticalContainer className={`${styles.intervalConfigRows} ${className}`} testId={testId}>
        {parts.map(part => {
            const config = draftIntervals[part];
            const oem = oemDefaults[part];

            if (!config || !oem) {
                return null;
            }

            return (
                <IntervalConfigRow
                    availableUnits={getAvailableUnits({ part })}
                    canReset={!isAtOemDefault({ current: config, oem })}
                    isEditable={isAdmin}
                    key={part}
                    label={partLabels[part]}
                    oemLabel={getOemLabel({ config: oem, strings })}
                    onChange={onChange}
                    onReset={onReset}
                    onUnitChange={onUnitChange}
                    part={part}
                    resetLabel={strings.INTERVAL_RESET_TO_DEFAULT}
                    unit={config.unit}
                    unitLabels={unitLabels}
                    unitSuffix={getUnitSuffix({ strings, unit: config.unit })}
                    value={config.value}
                />
            );
        })}
    </VerticalContainer>
);

export default IntervalConfigRows;
